export interface ComposerLlmModel {
  id: string;
  label: string;
  hint?: string;
}

export const COMPOSER_LLM_MODELS: readonly ComposerLlmModel[] = [
  { id: 'auto', label: 'Auto' },
  { id: 'claude-opus-4.7', label: 'Claude Opus 4.7' },
  { id: 'claude-sonnet-4.6', label: 'Claude Sonnet 4.6' },
  { id: 'claude-haiku-4.5', label: 'Claude Haiku 4.5' },
  { id: 'gpt-4o', label: 'GPT-4o' },
  { id: 'gpt-4o-mini', label: 'GPT-4o mini' },
  { id: 'gpt-4-turbo', label: 'GPT-4 Turbo' },
  { id: 'o3-mini', label: 'OpenAI o3-mini' },
  { id: 'gemini-pro', label: 'Gemini 2.5 Pro' },
  { id: 'gemini-flash', label: 'Gemini 2.5 Flash' },
  { id: 'grok', label: 'Grok 4' },
] as const;

export const DEFAULT_COMPOSER_LLM_MODEL_ID = 'auto';
